import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';
import { Subscription } from 'rxjs';
import { encrypt } from '../../service/utils';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent {

  pageSize: number = 1000;
  pageNo: number = 0;
  @Output() selectedUser = new EventEmitter<any>();
  @Input() orderId: any;
  productOrderHistory: Array<any> = [];


  currentUserSelected: any = null;
  commonListnerSubscription: Subscription;

  @ViewChildren('userCard') userCards!: QueryList<ElementRef>;

  constructor(private http: HttpService,
    public gS: GlobalService,
    private cdrf: ChangeDetectorRef
  ) {
    this.commonListnerSubscription = gS.commonListnerRefresh.subscribe((res: any) => {
      if (res?.type == 'selectUser') {
        if (res?.data) {
          this.currentUserSelected = res?.data;
        }
      }
      if (res?.type == 'UNREAD_COUNT_CHANGE') {
        this.productOrderHistory = this.productOrderHistory.map(user => {
          if (user.orderId === this.currentUserSelected.orderId) {
            return { ...user, unreaddCount: 0 };
          }
          return user;
        });
      }
    })
  }

  ngOnInit() {
    console.log(this.orderId, 'orderId');
    this.getProductOrder();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.commonListnerSubscription.unsubscribe();
  }

  formFields: any[] = [];

  getProductOrder() {
    console.log(this.gS.userData, 'payload');

    this.http.getProductOrderHistoryNew(this.gS.userData?.id, this.pageSize, this.pageNo).subscribe((data: any) => {
      let value: any = data;
      this.allProductOrderHistory = value?.data || [];
      this.productOrderHistory = [...this.allProductOrderHistory];
      this.productOrderHistory.forEach((item: any) => {
        this.formFields = [];
        if (item?.productIntakeFormFeild && item?.orderDetails) {
          let intakeFields = item?.productIntakeFormFeild;
          let orderDetails = item?.orderDetails;
          for (const key in intakeFields) {
            if (intakeFields[key] === true) {
              this.formFields.push({
                name: key,
                label: this.formatLabel(key),
                value: orderDetails[key] || '',
              });
            }
          }
          this.formFields = this.formFields.sort((a, b) => a.label.localeCompare(b.label));

          item.formFields = this.formFields;

          console.log(this.productOrderHistory, 'productOrderHistory');
        }
      })


      if (this.orderId) {
        this.productOrderHistory.forEach((item: any) => {
          console.log(item?.orderId, 'orderId');
          if (this.orderId == item?.orderId) {
            this.selectUser(item);
            setTimeout(() => {
              this.scrollToActiveUser();
            }, 10);
          }
        });
      }
    }, (error) => {
      console.log(error);
    });
  }

  scrollToActiveUser() {
    this.cdrf.detectChanges();

    const cardEl = this.userCards.find(el =>
      el.nativeElement.classList.contains('user_card_active')
    );

    if (cardEl) {
      cardEl.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  formatLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());
  }

  selectUser(item: any) {
    const encryptedOrderId = encrypt(item?.orderId?.toString());
    if (encryptedOrderId) {
      this.gS.navigateWithExtras('/customer-product-order-history', {
        queryParams: {
          // orderId: encryptedOrderId,
          orderId: item?.orderId,
        }
      });
    }
    this.selectedUser.emit(item);
  }

  searchTerm: string = '';
  allProductOrderHistory: any[] = [];

  onSearch(event: Event) {
    let input = event.target as HTMLInputElement | null;
    this.searchTerm = input?.value?.toLowerCase() || '';
    this.filterOrders();
  }

  clearSearch() {
    this.searchTerm = '';
    this.filterOrders();
  }

  filterOrders() {
    let value = this.searchTerm;
    if (!value) {
      this.productOrderHistory = [...this.allProductOrderHistory];
      return;
    }
  
    this.productOrderHistory = this.allProductOrderHistory.filter((item: any) => {
      let consultantName = item?.orderDetails?.consultantName?.toLowerCase() || '';
      let productName = item?.orderDetails?.productName?.toLowerCase() || '';
      return consultantName.includes(value) || productName.includes(value);
    });
  }

}
